export const calculateUpdatedValues = (originalBalance, adjustments) => {
  const { TotalPay, TotalPurchase } = originalBalance;
  const { payments, purchases } = adjustments;

  const parsedPaymentAdj = parseFloat(payments.adjustment) || 0;
  const parsedPurchaseAdj = parseFloat(purchases.adjustment) || 0;

  const updatedPayment = TotalPay + parsedPaymentAdj;
  const updatedPurchase = TotalPurchase + parsedPurchaseAdj;

  return {
    balance: {
      currentValue: TotalPay - TotalPurchase,
      updatedValue: updatedPayment - updatedPurchase,
    },
    payments: {
      currentValue: TotalPay,
      updatedValue: updatedPayment,
    },
    purchases: {
      currentValue: TotalPurchase,
      updatedValue: updatedPurchase,
    },
  };
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/changebalance/helpers/index.js